'use strict';

module.exports = function () {

  if (typeof localStorage === 'undefined') return {};

  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/storage.js
// module id = 1434
// module chunks = 0